(function () {
  if (customElements.get('product-custom-cards-row')) return;

  class ProductCustomCardsRow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-custom-cards-track]');
      this.prev = this.querySelector('[data-custom-cards-prev]');
      this.next = this.querySelector('[data-custom-cards-next]');
      if (!this.track || !this.prev || !this.next) return;

      this._onScroll = this._onScroll.bind(this);
      this._updateLayout = this._updateLayout.bind(this);

      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.prev.addEventListener('click', () => this._scroll(-1));
      this.next.addEventListener('click', () => this._scroll(1));

      this.resizeObserver = new ResizeObserver(this._updateLayout);
      this.resizeObserver.observe(this);
      window.addEventListener('resize', this._updateLayout);
      this._updateLayout();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._updateLayout);
      this.resizeObserver?.disconnect();
    }

    _scroll(direction) {
      const step = Math.max(Math.floor(this.track.clientWidth * 0.75), 160);
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    _updateLayout() {
      const { scrollWidth, clientWidth, scrollLeft } = this.track;
      const overflow = scrollWidth > clientWidth + 2;
      this.classList.toggle('product-custom-cards__host--scrollable', overflow);
      this.prev.hidden = !overflow;
      this.next.hidden = !overflow;
      if (overflow) this._onScroll();
      else {
        this.prev.disabled = true;
        this.next.disabled = true;
      }
    }

    _onScroll() {
      if (this.prev.hidden) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prev.disabled = scrollLeft <= 2;
      this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }

  customElements.define('product-custom-cards-row', ProductCustomCardsRow);
})();
